export default __webpack_public_path__ + "static/media/4t.1508fcaa.jpg";